export default __webpack_public_path__ + "static/media/41.4c412868.jpeg";